import { componentsThemeMap } from '../../componentsThemeMap.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { TwoColumnLayout } from '../../layout/TwoColumnLayout.js';
import { CTAButtons } from '../../ui/CTAButtons.js';
import '../../ui/Div/index.js';
import { EmailOnlyUserForm } from '../../ui/Form/EmailOnlyUserForm.js';
import { Text } from '../../ui/Text.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
function ActionBannerContent({
  headline,
  body,
  ctaType = 'links',
  ctaButtonLabel,
  ctaButtonUrl,
  secondaryButtonLabel,
  secondaryButtonUrl,
  successMessage,
  submitButtonLabel,
  placeholder,
  onSuccess,
  onSubmit,
  formType,
  alignContent,
  style
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    background = _componentsThemeMap$s.background,
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary;
  const isForm = ctaType === 'form';
  const isTwoColumns = alignContent === 'two-columns';
  const actionContent = isForm ? /*#__PURE__*/jsx(EmailOnlyUserForm, {
    submitButtonLabel: submitButtonLabel,
    successMessage: successMessage,
    placeholder: placeholder,
    onSuccess: onSuccess,
    onSubmit: onSubmit,
    style: style,
    formType: formType
  }) : /*#__PURE__*/jsx(CTAButtons, {
    ctaButtonLabel: ctaButtonLabel,
    ctaButtonUrl: ctaButtonUrl,
    secondaryButtonLabel: secondaryButtonLabel,
    secondaryButtonUrl: secondaryButtonUrl,
    contentBackground: background
  });
  return /*#__PURE__*/jsx(SectionComponentLayout, {
    hasSpacingHorizontal: true,
    hasSpacingVertical: true,
    flexDirection: "row",
    height: "100%",
    background: "transparent",
    children: /*#__PURE__*/jsx(Div, {
      alignItems: "center",
      flex: 1,
      children: /*#__PURE__*/jsx(TwoColumnLayout, {
        mainContentPosition: isTwoColumns ? 'left' : 'top',
        wrapOnTablet: true,
        gap: 4,
        mainContent: /*#__PURE__*/jsx(Div, {
          flex: 1,
          children: /*#__PURE__*/jsx(Text, {
            variant: {
              sm: 'title2',
              lg: 'display2'
            },
            as: "h2",
            color: foreground,
            children: headline
          })
        }),
        secondaryContent: /*#__PURE__*/jsxs(Div, {
          flexDirection: "column",
          gap: 3,
          width: "100%",
          flex: 1,
          children: [body && /*#__PURE__*/jsx(Text, {
            variant: "body",
            as: "p",
            spacingTop: isTwoColumns ? {
              sm: 2,
              lg: 0
            } : 2,
            color: foregroundSecondary,
            children: body
          }), /*#__PURE__*/jsx(Div, {
            justifyContent: isTwoColumns ? {
              sm: 'center',
              lg: 'flex-start'
            } : 'flex-start',
            children: actionContent
          })]
        })
      })
    })
  });
}
export { ActionBannerContent };
//# sourceMappingURL=ActionBannerContent.js.map
